const Theme = {
  logo_image_url: 'poesie.png',
  logo_height: 100,

  button_color: '#67bfa7',
  button_text_color: '#040504',
  button_text_weight: 400,
  button_half_border_color: '#d8292f',

  text_font: `'Open Sans', sans-serif`,
  text_color: 'black',
  title_font: `'Open Sans', Arial, sans-serif`,
}

export default Theme
